import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-self-serve }}\n{{outlet}}\n<GoogleTagManagerFrameComponent />",{ moduleName: "embercom/templates/signup.hbs" })